'use client';

import { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  alpha,
} from '@mui/material';
import {
  WhatsApp,
  Email,
  ArrowBack,
  ContentCopy,
  Check,
} from '@mui/icons-material';
import { useAppTheme } from '../../context/theme.context';

const SoporteModal = ({ open, handleClose }) => {
  const { colors } = useAppTheme();
  const [showEmails, setShowEmails] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState(null);

  const whatsappLink = 'https://wa.me/message/7M7JGJCASIHAE1';
  const emails = [
    'octavio@autoapp.com.ar',
    'renzo@autoapp.com.ar',
    'lautaro@autoapp.com.ar',
  ];

  const handleWhatsAppClick = () => window.open(whatsappLink, '_blank');

  const handleEmailClick = async (email) => {
    try {
      await navigator.clipboard.writeText(email);
      setCopiedEmail(email);
      setTimeout(() => setCopiedEmail(null), 2000);
    } catch (err) {
      console.error('Error al copiar el correo:', err);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
        <Paper
          elevation={0}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            maxWidth: '90%',
            bgcolor: 'background.paper',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0, 124, 162, 0.2)',
            border: '1px solid rgba(0, 124, 162, 0.1)',
            p: 0,
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              p: 3,
              background:
                'linear-gradient(135deg, rgba(0, 124, 162, 0.05) 0%, rgba(0, 95, 127, 0.02) 100%)',
              borderBottom: '1px solid rgba(0, 124, 162, 0.1)',
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 700, color: colors.primary }}>
              Soporte técnico
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {!showEmails
                ? 'Selecciona un método de contacto'
                : 'Selecciona un correo electrónico'}
            </Typography>
          </Box>

          <Box sx={{ p: 3 }}>
            {!showEmails ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Button
                  variant="outlined"
                  startIcon={<WhatsApp />}
                  onClick={handleWhatsAppClick}
                  sx={{
                    py: 1.5,
                    borderRadius: 2,
                    borderColor: '#25D366',
                    color: '#25D366',
                    '&:hover': {
                      borderColor: '#25D366',
                      backgroundColor: alpha('#25D366', 0.05),
                    },
                  }}
                >
                  Contactar por WhatsApp
                </Button>

                <Button
                  variant="contained"
                  startIcon={<Email />}
                  onClick={() => setShowEmails(true)}
                  sx={{
                    py: 1.5,
                    borderRadius: 2,
                    background:
                      `linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%)`,
                    '&:hover': {
                      background:
                        `linear-gradient(135deg, ${colors.primaryDark} 0%, ${colors.primary} 100%)`,
                    },
                  }}
                >
                  Contactar por Email
                </Button>
              </Box>
            ) : (
              <Box>
                <List sx={{ mb: 2 }}>
                  {emails.map((email) => (
                    <ListItem key={email} disablePadding sx={{ mb: 1 }}>
                      <ListItemButton
                        onClick={() => handleEmailClick(email)}
                        sx={{
                          borderRadius: 2,
                          border: '1px solid rgba(0, 124, 162, 0.1)',
                          '&:hover': {
                            backgroundColor: alpha(colors.primary, 0.05),
                          },
                        }}
                      >
                        <ListItemText primary={email} />
                        {copiedEmail === email ? (
                          <Check sx={{ color: 'green' }} />
                        ) : (
                          <ContentCopy
                            sx={{ color: colors.primary, fontSize: '0.9rem' }}
                          />
                        )}
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>

                <Button
                  variant="outlined"
                  startIcon={<ArrowBack />}
                  onClick={() => setShowEmails(false)}
                  fullWidth
                  sx={{
                    borderRadius: 2,
                    borderColor: colors.primary,
                    color: colors.primary,
                    '&:hover': {
                      borderColor: colors.primaryDark,
                      backgroundColor: alpha(colors.primary, 0.05),
                    },
                  }}
                >
                  Volver
                </Button>
              </Box>
            )}
          </Box>
        </Paper>
    </Modal>
  );
};

export default SoporteModal;
